import { Button, MobileStepper, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../hooks";

const NavigationBar = ({
  previousStep,
  totalSteps,
  step,
  isLoading,
  nextDisabled,
}) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <MobileStepper
      variant="dots"
      steps={totalSteps}
      position={isMobile ? "bottom" : "static"}
      activeStep={step - 1}
      sx={{
        alignContent: "center",
        display: "flex",
        justifyContent: "center",
        left: 0,
        right: 0,
        position: { xs: "none", sm: "none", md: "absolute" },
        mt: { sx: 0, md: 8 },
        width: "auto",
        ...(!isMobile && {
          "& .MuiMobileStepper-dots": {
            position: "absolute",
            top: "-15px",
            left: "49%",
            transform: "translateX(-50%)",
          },
        }),
        "& .MuiMobileStepper-dotActive": {
          width: 15,
          borderRadius: 1,
        },
      }}
      backButton={
        <Button
          variant="outlined"
          sx={{ pr: 3, mr: 1.5 }}
          onClick={() => (step === 1 ? navigate("/") : previousStep())}
        >
          <KeyboardArrowLeft />
          Atrás
        </Button>
      }
      nextButton={
        step < totalSteps ? (
          <Button
            type="submit"
            variant="contained"
            sx={{ pl: 3, ml: 1.5 }}
            disabled={nextDisabled}
          >
            Siguiente
            <KeyboardArrowRight />
          </Button>
        ) : (
          <LoadingButton
            type="submit"
            variant="contained"
            sx={{ ml: 1.5 }}
            loading={isLoading}
          >
            Finalizar
            <KeyboardArrowRight />
          </LoadingButton>
        )
      }
    />
  );
};
export default NavigationBar;
